import Vue from 'vue'
import VueRouter from 'vue-router'

import routes from './routes'

Vue.use(VueRouter)

export const router = new VueRouter({
    routes,
    mode: 'history'
})
    // const Router = new VueRouter({
    //     // scrollBehavior: () => ({x: 0, y: 0}),
    //     routes,
    //     mode: 'history'
    // })
    // Router.beforeEach((to, from, next) => {})

    // return Router

